
const themeDefaults = {
  borderRadius: 4,
  colors: {
    primary: 'rgba(45, 93, 231, 1)',
    orangeEnergy: 'rgba(252, 83, 31, 1)',
    mediumGreen: 'rgba(27, 180, 131, 1)',
  },
};
export default themeDefaults;
